import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { type IconProp } from '@fortawesome/fontawesome-svg-core';

export type ButtonColorType = 'neutral' | 'primary' | 'positive' | 'negative' | 'progress' | 'ai';
export type ButtonSizeType = 'small' | 'normal' | 'full-width';
export type ButtonIconSlotType = 'start' | 'end';
export type ButtonTextAlignType = 'start' | 'center';

@Component({
  selector: 'rcp-button',
  template: `
    <button
      class="rcp-button"
      [class.primary]="color() === 'primary'"
      [class.positive]="color() === 'positive'"
      [class.negative]="color() === 'negative'"
      [class.progress]="color() === 'progress'"
      [class.ai]="color() === 'ai'"
      [class.disabled]="disabled()"
      [class.active]="active()"
      [class.rcp-button-small]="size() === 'small'"
      [class.rcp-button-full-width]="size() === 'full-width'"
      [title]="title()"
      [class]="textAlign()"
      [attr.type]="buttonType()"
      [name]="name()"
    >
      @if (icon() && iconSlot() === 'start') {
        <span class="button-icon">
          <fa-icon [icon]="icon()" />
        </span>
      }
      <span class="button-label">
        <span class="button-label-content ellipsis">
          <ng-content />
        </span>
      </span>
      @if (icon() && iconSlot() === 'end') {
        <span class="button-icon">
          <fa-icon [icon]="icon()" />
        </span>
      }
    </button>
  `,
  styleUrls: ['./button.component.scss'],
  imports: [FontAwesomeModule],
  changeDetection: ChangeDetectionStrategy.Eager,
  host: {
    '[class.disabled]': 'disabled()',
  },
})
export class ButtonComponent {
  // NOTE: LinkButtonComponent extends this component, so make sure to keep features in syncs
  readonly icon = input<IconProp>();
  readonly iconSlot = input<ButtonIconSlotType>('start');
  readonly color = input<ButtonColorType>('neutral');
  readonly active = input(false);
  readonly size = input<ButtonSizeType>('normal');
  readonly disabled = input(false);
  readonly title = input('');
  readonly textAlign = input<ButtonTextAlignType>('center'); // where we want the text to be aligned
  readonly name = input<string>();
  readonly buttonType = input<HTMLButtonElement['type']>('button');
}
